/* import __COLOCATED_TEMPLATE__ from './unsaved-changes-modal-old.hbs'; */
import { assert } from '@ember/debug';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import { CLOSE_NAVIGATION } from '@square/glass-ui/services/modal';
import Enum from '@square/dashboard-utilities/utils/enum';
import { computed } from '@ember/object';

/**

## Overview

Modal for prompting the user to decide what do if they try to leave when they have unsaved changes.
The user can Save Changes, Discard Changes, or Cancel with the X. It will be opened by the unsaved changes handler.

```
*/

export const UnsavedChangesModalChoice = new Enum('SAVE', 'DISCARD', 'CANCEL');
const {
  SAVE,
  DISCARD,
  CANCEL
} = UnsavedChangesModalChoice;

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  intl: service(),
  titleText: computed('modalOptions.titleText', function () {
    if (this.modalOptions && this.modalOptions.titleText) {
      return this.modalOptions.titleText;
    } else {
      return this.intl.t('common.unsavedChanges.header');
    }
  }),
  bodyText: computed('modalOptions.bodyText', function () {
    if (this.modalOptions && this.modalOptions.bodyText) {
      return this.modalOptions.bodyText;
    } else {
      return this.intl.t('common.unsavedChanges.message');
    }
  }),
  saveButtonVariant: readOnly('modalOptions.saveButtonVariant'),
  saveButtonText: computed('modalOptions.saveButtonText', function () {
    if (this.modalOptions && this.modalOptions.saveButtonText) {
      return this.modalOptions.saveButtonText;
    } else {
      return this.intl.t('common.unsavedChanges.save');
    }
  }),
  discardButtonText: computed('modalOptions.discardButtonText', function () {
    if (this.modalOptions && this.modalOptions.discardButtonText) {
      return this.modalOptions.discardButtonText;
    } else {
      return this.intl.t('common.unsavedChanges.dontSave');
    }
  }),
  isWarning: readOnly('modalOptions.isWarning'),
  didInsertElement(...args) {
    this._super(...args);
    assert('The unsaved changes modal should only be used the with modal service', this.setCloseHandler);
    this.setCloseHandler(reason => reason === CLOSE_NAVIGATION ? false : CANCEL);
  },
  SAVE,
  DISCARD
});